export function Schema({ page }) {
  if (page?.handle !== 'search') return null;

  return {
    label: 'Search Results',
    key: 'search-results',
    fields: [],
  };
}
